/* AMTENDENCY — slider duplo do filtro de preço.

   O Dawn traz só os dois campos numéricos; a referência tem um slider por
   cima deles. As duas alças são <input type="range"> sobrepostos: acessíveis
   por teclado de graça e sem uma linha de arrasto manual.

   Contrato do Dawn: `PriceRange.setMinAndMaxValues` (facets.js:406) lê
   `querySelectorAll('input')[0]` e `[1]` dentro de <price-range>. Por isso o
   markup do slider é o ÚLTIMO filho — mexer nessa ordem quebra a validação
   de mínimo/máximo. */
(function () {
  function campos(faixa) {
    var pr = faixa.closest('price-range');
    if (!pr) return null;
    // os dois primeiros continuam sendo os campos de texto do Dawn
    var texto = pr.querySelectorAll('input[type="text"]');
    return texto.length >= 2 ? { de: texto[0], ate: texto[1] } : null;
  }

  function pinta(faixa, de, ate) {
    faixa.style.setProperty('--am-faixa-de', de);
    faixa.style.setProperty('--am-faixa-ate', ate);
  }

  /* enquanto arrasta: só o desenho se mexe, sem disparar busca a cada pixel */
  function aoMover(e) {
    var alca = e.target;
    var faixa = alca.closest('[data-am-faixa]');
    if (!faixa) return;

    var de = faixa.querySelector('[data-am-faixa-de]');
    var ate = faixa.querySelector('[data-am-faixa-ate]');
    // as alças não se cruzam
    if (Number(de.value) > Number(ate.value)) {
      if (alca === de) de.value = ate.value;
      else ate.value = de.value;
    }
    pinta(faixa, de.value, ate.value);
  }

  /* ao soltar: escreve nos campos do Dawn e deixa o facets.js buscar.
     O `input` é o evento que o FacetFiltersForm escuta (facets.js:11). */
  function aoSoltar(e) {
    var faixa = e.target.closest('[data-am-faixa]');
    if (!faixa) return;
    var c = campos(faixa);
    if (!c) return;

    var de = faixa.querySelector('[data-am-faixa-de]');
    var ate = faixa.querySelector('[data-am-faixa-ate]');
    var teto = Number(faixa.style.getPropertyValue('--am-faixa-teto')) || Number(ate.max);

    // vazio quer dizer "sem limite" — é assim que a Shopify entende o filtro
    c.de.value = Number(de.value) > 0 ? PriceRange.format(de.value) : '';
    c.ate.value = Number(ate.value) < teto ? PriceRange.format(ate.value) : '';

    c.ate.dispatchEvent(new Event('input', { bubbles: true }));
    c.ate.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* digitar nos campos move as alças de volta */
  function aoDigitar(e) {
    var pr = e.target.closest('price-range');
    if (!pr || e.target.type !== 'text') return;
    var faixa = pr.querySelector('[data-am-faixa]');
    if (!faixa) return;
    var c = campos(faixa);
    if (!c) return;
    var teto = Number(faixa.querySelector('[data-am-faixa-ate]').max);
    var de = faixa.querySelector('[data-am-faixa-de]');
    var ate = faixa.querySelector('[data-am-faixa-ate]');
    de.value = c.de.value === '' ? 0 : PriceRange.parse(c.de.value);
    ate.value = c.ate.value === '' ? teto : PriceRange.parse(c.ate.value);
    pinta(faixa, de.value, ate.value);
  }

  // delegação: o facets.js troca o painel inteiro a cada filtro aplicado
  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches('[data-am-faixa] input[type="range"]')) aoMover(e);
    else if (e.target.matches && e.target.matches('price-range input[type="text"]')) aoDigitar(e);
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-am-faixa] input[type="range"]')) aoSoltar(e);
    else if (e.target.matches && e.target.matches('price-range input[type="text"]')) aoDigitar(e);
  });
})();
